import _ from 'lodash';
import {AstView} from '../types';
import {convertAbsToFlex} from './ConvertAbsToFlex';
import {calculateLayoutSettings} from './CalculateLayoutSettings';
import {calculateLayoutStable} from './CalculateLayoutSettingsStable';
import {applySizingFromSettings} from './ApplySizingFromSettings';
import {
    removeDeadUserGroups,
    resizeDynamicSizedGroups,
    removeAllSystemGroups,
} from './ConvertAbsToFlex/ResizeDymanicSizedGroups.optimizer';
import {callWithNote} from '../helpers/CallStackContextHelper';

export type RepairMode = 'lock' | 'change' | 'tryLock';
// run simulation in here...

export async function repair(inputView: AstView, repairMode: RepairMode) {
    const view = _.cloneDeep(inputView); // probably move clone out.
    if (repairMode === 'lock') {
        return await repairWithVisualLock(view);
    } else if (repairMode === 'change') {
        return await repairWithVisualChange(view);
    } else {
        return await tryRepairWithVisualLock(view);
    }
}

async function repairWithVisualLock(inputView: AstView) {
    ToRepair.forEach((fn) => {
        fn(inputView.tree, inputView);
    });

    return inputView;
}

/*
 * Tries to repair without changing but if would override user settings fall back.
 */
export async function tryRepairWithVisualLock(inputView: AstView) {
    const tryWithLock: AstView = _.cloneDeep(inputView);

    const [notes] = await callWithNote(async () => {
        await repairWithVisualLock(tryWithLock);
    });
    if (notes.length > 0) {
        console.log('notes', notes);
    }

    if (notes.length === 0) {
        return tryWithLock;
    } else {
        return await repairWithVisualChange(inputView);
    }
}

async function repairWithVisualChange(input: AstView) {
    // applySizingFromSettings
    calculateLayoutStable(input.tree, input);
    // do some calc.
    applySizingFromSettings(input.tree, input);
    // sync after
    return input;
}

export const ToRepair = [
    removeAllSystemGroups,
    removeDeadUserGroups,
    resizeDynamicSizedGroups, // not sure if we still use this.
    calculateLayoutSettings,
    convertAbsToFlex,
    applySizingFromSettings,
];

export const SmallRepairList = [calculateLayoutSettings, convertAbsToFlex, applySizingFromSettings];

export function internalCompilerRepair({view: inputView}: {view: AstView}) {
    const view = _.cloneDeep(inputView);

    SmallRepairList.forEach((fn) => {
        fn(view.tree, view);
    });

    return view;
}
